export * from './school.model';
export * from './school-popup.service';
export * from './school.service';
export * from './school-dialog.component';
export * from './school-delete-dialog.component';
export * from './school-detail.component';
export * from './school.component';
export * from './school.route';
export * from './school.typeahead.service';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school/index.ts